// @flow
// @jsx h

// External librairies
import { h } from "preact";
import { Text } from "preact-i18n";
import Link from "../link";
import { ArrowLeftIcon } from "elc-icons";
import styles from "./PaymentConfirmation.scss";
import { ThemeConfig } from "elc-theme";

// Components
import PaymentAssurance from "../payment-assurance";
import CreditCardConfirmation from "./CreditCardConfirmation";
import FreeOrderConfirmation from "./FreeOrderConfirmation";
import FullyPaidConfirmation from "./FullyPaidConfirmation";
import ParticipantsFormsLink from "./ParticipantsFormsLink";

/**
 * Component displaying the payment confirmation
 * depending on the chosen payment method
 */
const PaymentConfirmation = ({
  hash,
  config,
  locale,
  currency,
  order,
  payment,
  paymentMethod,
  dataAssurance,
  getAssurance,
  initAssuranceMeetch
}: {
  hash: string,
  config: WidgetConfig,
  locale: string,
  currency: Currency,
  order: Order,
  payment: Payment,
  paymentMethod: PaymentMethod,
  dataAssurance: object | null,
  getAssurance: Function,
  initAssuranceMeetch: Object
}) => {
  let _paymentObject = typeof payment !== "undefined" ? payment : paymentMethod;

  let _paymentMethod = paymentMethod
    ? paymentMethod.baseModule.code
    : undefined;

  return (
    <ThemeConfig.Consumer>
      {(themeConfig) => {
        return (
          <div class={styles.column}>
            {dataAssurance ? (
              <PaymentAssurance config={config} locale={locale} dataAssurance={dataAssurance} getAssurance={getAssurance} initAssuranceMeetch={initAssuranceMeetch}/>
            ) : (
              <div>
                {_paymentObject ? (
                  order ? (
                    _paymentMethod === "creditcard" ? (
                      <CreditCardConfirmation
                        hash={hash}
                        config={config}
                        currency={currency}
                        payment={payment}
                        paymentMethod={paymentMethod}
                        locale={locale}
                      />
                    ) : _paymentMethod === "freeorder" ? (
                      <FreeOrderConfirmation />
                    ) : _paymentMethod === "fullypaid" ? (
                      <FullyPaidConfirmation />
                    ) : (
                      <div>Unknown payment method</div>
                    )
                  ) : _paymentMethod === "freeorder" ? (
                    <FreeOrderConfirmation />
                  ) : (
                    <div>Unknown payment method</div>
                  )
                ) : (
                  <div>No payment or no order</div>
                )}
                <div>
                  {hash && (
                    <Link
                      href={`/${hash}/products`}
                      className={styles.newOrderButton}
                    >
                      <ArrowLeftIcon
                        color={
                          themeConfig && themeConfig.color1
                            ? themeConfig.color1
                            : styles.arrowColor
                        }
                      />
                      <Text id="payment.confirmation.newOrder">
                        Pass a new order
                      </Text>
                    </Link>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      }}
    </ThemeConfig.Consumer>
  );
};

export default PaymentConfirmation;
